import React from 'react';
import { Monitor, Smartphone } from 'lucide-react';

// Top-right switcher between the web (sidebar) and app/tablet (bottom-nav) layouts.
// Shows the icon of the mode you'd switch TO, so it reads as an action button.
export default function ViewModeToggle({ viewMode, onToggle }) {
  const goingToApp = viewMode === 'web';
  return (
    <button
      onClick={onToggle}
      title={goingToApp ? 'Switch to Tablet/Mobile App version' : 'Switch to Web version'}
      style={{
        display: 'flex', alignItems: 'center', gap: 6, background: 'none',
        border: '1px solid var(--border)', borderRadius: 6, cursor: 'pointer',
        color: 'var(--text-muted)', padding: '6px 8px', fontSize: '.75rem', fontWeight: 600,
      }}
    >
      {goingToApp ? <Smartphone size={15} /> : <Monitor size={15} />}
      <span className="view-toggle-label">{goingToApp ? 'App View' : 'Web View'}</span>
    </button>
  );
}
